module.exports = "<div class='kng-footer' ><ng-content></ng-content></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-footer/kng-footer.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-footer/kng-footer.component.html
// module chunks = main